export const CurrencyTypes = {
  VIRTUAL: "VIRTUAL",
  REAL: "REAL",
  VIRTUAL_AND_REAL: "VIRTUAL_AND_REAL",
};
